import {
    MoreHorizontal,
    Building2, EditIcon, PrinterIcon, Trash,
} from "lucide-react"

import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuSeparator,
    DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu"
import {
    SidebarGroup,
    SidebarGroupLabel,
    SidebarMenu,
    SidebarMenuAction,
    SidebarMenuButton,
    SidebarMenuItem,
    useSidebar,
} from "@/components/ui/sidebar"

import {Document} from "@/pages/documents/columns"
import axios from "axios";
import {Link, NavLink} from "react-router";
import {
    AlertDialog,
    AlertDialogAction,
    AlertDialogCancel,
    AlertDialogContent, AlertDialogDescription, AlertDialogFooter,
    AlertDialogHeader,
    AlertDialogTitle,
    AlertDialogTrigger
} from "@/components/ui/alert-dialog.tsx";
import {Button} from "@/components/ui/button.tsx";
import {useAuth} from "react-oidc-context";

export function NavProjects({
                                projects,
                            }: {
    projects: Document[] | undefined
}) {
    const {isMobile} = useSidebar()
    const auth = useAuth()

    return (
        <SidebarGroup className="group-data-[collapsible=icon]:hidden">
            <SidebarGroupLabel>Legutóbbi tanulmányaim</SidebarGroupLabel>
            <SidebarMenu>
                {projects?.map((item) => (
                    <SidebarMenuItem key={item.company_name}>
                        <SidebarMenuButton asChild>
                            <Link to={"/documents/" + item.id}>
                                <Building2/>
                                <span>{item.company_name}</span>
                            </Link>
                        </SidebarMenuButton>
                        <DropdownMenu>
                            <DropdownMenuTrigger asChild>
                                <SidebarMenuAction showOnHover>
                                    <MoreHorizontal/>
                                    <span className="sr-only">More</span>
                                </SidebarMenuAction>
                            </DropdownMenuTrigger>
                            <DropdownMenuContent
                                className="w-48 rounded-lg"
                                side={isMobile ? "bottom" : "right"}
                                align={isMobile ? "end" : "start"}
                            >
                                <DropdownMenuItem asChild>
                                    <NavLink to={`/documents/${item.id}/edit`}>
                                        <EditIcon className="text-muted-foreground"/>
                                        Módosítás
                                    </NavLink>
                                </DropdownMenuItem>
                                <DropdownMenuItem onClick={(e) => {
                                    e.stopPropagation();
                                    window.open(`/api/print/${item.id}?api_key=${auth?.user?.access_token}`, "_blank");
                                }}>

                                    <PrinterIcon className="text-muted-foreground"/>
                                    Irodai verzió
                                </DropdownMenuItem>
                                <DropdownMenuItem onClick={(e) => {
                                    e.stopPropagation();
                                    window.open(`/api/print/${item.id}?press=true&api_key=${auth?.user?.access_token}`, "_blank");
                                }}>
                                    <PrinterIcon className="text-muted-foreground"/>
                                    Nyomdai verzió
                                </DropdownMenuItem>
                                <DropdownMenuSeparator/>
                                <DropdownMenuItem asChild>
                                    <AlertDialog>
                                        <AlertDialogTrigger asChild>
                                            <Button variant={'link'}
                                                    className={"text-destructive hover:text-red-700 hover:no-underline hover:bg-secondary"}
                                                    onClick={(e) => e.stopPropagation()}><Trash/> Törlés</Button>
                                        </AlertDialogTrigger>
                                        <AlertDialogContent onClick={(e) => e.stopPropagation()}>
                                            <AlertDialogHeader>
                                                <AlertDialogTitle>Biztosan törli a dokumentumot?</AlertDialogTitle>
                                                <AlertDialogDescription>
                                                    Ez a művelet nem vonható vissza. A dokumentum és az ahhoz rögzített
                                                    adatok véglegesen el fognak veszni.
                                                </AlertDialogDescription>
                                            </AlertDialogHeader>
                                            <AlertDialogFooter>
                                                <AlertDialogCancel onClick={(e) => {
                                                    e.stopPropagation()
                                                }}>Mégse</AlertDialogCancel>
                                                <AlertDialogAction className={"bg-destructive hover:bg-red-700"}
                                                                   onClick={(e) => {
                                                                       e.stopPropagation()
                                                                       axios.delete(`/api/documents/${item.id}`).then(res => {
                                                                           if (res.status === 204) {
                                                                               window.location.reload();
                                                                           }
                                                                       })
                                                                   }}>Törlés</AlertDialogAction>
                                            </AlertDialogFooter>
                                        </AlertDialogContent>
                                    </AlertDialog>
                                </DropdownMenuItem>
                            </DropdownMenuContent>
                        </DropdownMenu>
                    </SidebarMenuItem>
                ))}
            </SidebarMenu>
        </SidebarGroup>
    )
}
